import { Text } from "@chakra-ui/react";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { StateProps } from "components/pipeline-components/classes/state-machine/state";
import { DiagnosticPanel } from "./DiagnosticPanel";

export function StartEndEditor({
  selectedStateId,
  pipelineData,
  operation,
  diagnosticUpdatePipelineData
}: {
  selectedStateId?: number;
  pipelineData?: StatesMachine;
  operation?: StateProps["operation"];
  diagnosticUpdatePipelineData?: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
}) {
  return (
    <>
      <Text color="#90a1b9" fontWeight="600" fontSize="sm">
        Este nó não possui configurações editáveis.
      </Text>
      {selectedStateId != null &&
        pipelineData &&
        diagnosticUpdatePipelineData &&
        operation && (
          <DiagnosticPanel
            selectedStateId={selectedStateId}
            pipelineData={pipelineData}
            operation={operation}
            updatePipelineData={diagnosticUpdatePipelineData}
          />
        )}
    </>
  );
}
